const apiBase = {
  queryBannerList: '/api/show/queryBannerList',//获取banner

}
let HomeSeverObject = null
class HomeSever {
  constructor() {}
  queryBannerList(params = {}) {
    return $http({
      method: 'post',
      url: apiBase.queryBannerList,
      data: params
    })
  }
}

function singleHomeSever() {
  if (HomeSeverObject === null) {
    HomeSeverObject = new HomeSever()
  }
  return HomeSeverObject
}
export default singleHomeSever()